import React, { createContext, useContext, useState, useCallback, useMemo } from "react";

interface ExerciseContext {
  exercise_id: number;
  exercise_name: string;
  exercise_type: string;
  instructions?: string;
}

interface AIChatContextValue {
  moduleId: number;
  moduleName: string;
  courseId: number;
  exerciseContext?: ExerciseContext;
  setContext: (ctx: { moduleId: number; moduleName: string; courseId: number; exerciseContext?: ExerciseContext }) => void;
  clearContext: () => void;
}

const AIChatCtx = createContext<AIChatContextValue>({
  moduleId: 0,
  moduleName: "General",
  courseId: 0,
  setContext: () => {},
  clearContext: () => {},
});

export const useAIChatPageContext = () => useContext(AIChatCtx);

export const AIChatProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [state, setState] = useState({
    moduleId: 0,
    moduleName: "General",
    courseId: 0,
    exerciseContext: undefined as ExerciseContext | undefined,
  });

  const setContext = useCallback((ctx: { moduleId: number; moduleName: string; courseId: number; exerciseContext?: ExerciseContext }) => {
    setState({ ...ctx, exerciseContext: ctx.exerciseContext });
  }, []);

  const clearContext = useCallback(() => {
    setState({ moduleId: 0, moduleName: "General", courseId: 0, exerciseContext: undefined });
  }, []);

  const value = useMemo(() => ({ ...state, setContext, clearContext }), [state, setContext, clearContext]);

  return <AIChatCtx.Provider value={value}>{children}</AIChatCtx.Provider>;
};
